/**
 * The type of the action which shows/hides the rendering measurement panel.
 *
 * {
 *     type: SET_RENDER_STATS,
 *     open: boolean
 * }
 */
export const SET_RENDER_STATS = 'SET_RENDER_STATS';
